module.exports = __webpack_public_path__ + "img/symbol_6.3e7c06a7.png";